import { Fragment, useCallback, useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, formatCurrency } from "../../Utility/utility"
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { parse } from "@fortawesome/fontawesome-svg-core"
import { useNavigate, } from "react-router-dom"
import { setDetailLotno } from "../../state/stockEntrySlice"
import { toast } from "react-toastify"
import jsPDF from "jspdf"
import { autoTable } from "jspdf-autotable"
import { Button, Checkbox, Select, SelectItem } from "@heroui/react"
import { Box, Chip, Autocomplete, TextField, Typography } from "@mui/material"
import { faFile, faFilter, faInfo, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { resetDetail } from "../../state/polishSizeSlice";



const ParamWisePositionReport = () => {
    const { compCode, compName } = useSelector((state) => state.company);

    const [isStkAtWise, setIsStkAtWise] = useState(true);
    const [reportType, setReportType] = useState("SNG");
    const [groupType, setGroupType] = useState("size");
    const [selectedLots, setSelectedLots] = useState([]);
    const [selShape, setSelShape] = useState([]);

    const navigate = useNavigate()
    const [selColor, setSelColor] = useState(new Set([]))
    const [selFancyColor, setSelFancyColor] = useState(new Set([]))
    const [selPurity, setSelPurity] = useState(new Set([]))
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState({
        shape: [],
        size: [],
    });

    /* ===================== STYLES ===================== */
    const tableClass = "table-auto border-collapse  border border-gray-700 text-sm min-w-max";
    const headerCell = "border border-gray-700 px-2 py-1 text-center uppercase  font-bold";
    const subHeaderCell = "border border-gray-700 px-2 py-2 font-semibold text-sm text-center bg-gray-100";
    const cellClass = "text-center p-1";

    const stickyFilterCell = "px-0 bg-gray-50 "
    const StickyLeftCellShape =
        "sticky left-0 z-20  font-bold w-[200px]  px-2  shadow-[2px_0_6px_rgba(0,0,0,0.15)]";

    const StickyLeftCellSize =
        "sticky left-[200px] z-20 w-[140px] [background-clip:padding-box]   font-bold px-2  shadow-[2px_0_6px_rgba(0,0,0,0.12)]";

    const STOCK_UI = {
        dynamic: {
            head: "bg-red-100 text-red-700 border-red-200 p-2",
            body: "bg-red-50 text-red-700",
            total: "bg-red-200 text-red-900 font-semibold",
        },
        fixed: {
            head: "bg-emerald-100 text-emerald-900 border-emerald-200",
            body: "bg-emerald-50 text-emerald-800",
            total: "bg-emerald-200 text-emerald-900 font-semibold",
        },
        mix: {
            head: "bg-blue-100 text-blue-900 border-blue-200",
            body: "bg-blue-50 text-blue-800",
            total: "bg-blue-200 text-blue-900 font-semibold",
        },
        grand: {
            head: "bg-gray-300 text-gray-900",
            body: "bg-gray-300 text-gray-900 font-bold",
        }
    };



    const getStockClass = (type, part = "body") => {
        return STOCK_UI?.[type]?.[part] || "";
    };
    const STOCK_CELL_STYLE = {
        dynamic:
            "bg-gradient-to-r from-white to-red-50 border-1  text-xs font-semibold text-red-800 border-red-200",
        fixed:
            "bg-gradient-to-r from-white to-emerald-50 border-1 text-xs font-semibold  text-emerald-900 border-emerald-200",
        mix:
            "bg-gradient-to-r from-white to-blue-50  border-1 text-xs font-semibold  text-blue-900 border-blue-200",
        total:
            "bg-gradient-to-r from-white to-blue-100 border-1    text-blue-900 font-semibold border-blue-300",
    };

    const STOCK_BORDER = {
        dynamic: "border-l-2 border-red-200",
        fixed: "border-l-2 border-emerald-200",
        mix: "border-l-2 border-blue-200",
        total: "border-l-2 border-blue-500",
    };

    const getStockStyle = (type) => STOCK_CELL_STYLE[type] || "";
    const getStockBorder = (type) => STOCK_BORDER[type] || "";
    const formField = {
        colorCode: "colorCode",
        purityCode: "purityCode",
    }
    /* ===================== FETCH DATA ===================== */
    const {isPending,isError, data = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.getParamWiseData,
        queryKey: "ParamwiseDatastck",
    });
    const { data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "StockItemMaster",
    })

    const funLoadData = (color, purity) => {

        const getValue = (obj) => { return Array.from(obj).join(",") }
        filterData({
            data: {
                comp_code: compCode.join(","),
                trade_of: "P",
                sha_code: color != "" && color != null ? getValue(color) : null,
                q_code: purity != "" && purity != null ? getValue(purity) : null,
            }
        });
    }


    /* ===================== COLUMN CONFIG ===================== */
    const fixedStkAtTypes = ["MemoMix", "MemoSng"];
    const fixedStkAtHeader = {
        InwardMix: "Inward Mix",
        InwardSng: "Inward Single",
        SaleMix: "Sale Mix",
        SaleSng: "Sale Single",
        "Total Inw": "Total Inward",
        "Total Sale": "Total Sale",
        MemoMix: "ON Memo",
        MemoSng: "On Memo",
        "MixStock": "Mix Stock",
        "TotalStock": "Total Stock",
        "SingleStock": "Single Stock",

    };

    /* ===================== VISIBLE COLUMNS ===================== */
    const visibleFixedCols = useMemo(() => {
        if (reportType === "MIX") return ["MemoMix"];//"SaleMix"
        if (reportType === "SNG") return ["MemoSng"];// "SaleSng",
        return fixedStkAtTypes; // BOTH
    }, [reportType]);

    const showMixStock = reportType === "MIX";
    const showDynamicStock = reportType !== "MIX";
    const showTotalStock = reportType !== "MIX";
    const showTotalsColumns = false // reportType === "BOTH";

    /* ===================== GROUP DATA ===================== */
    const filteredByRptType = useMemo(() => {
        if (reportType === "SNG") {
            return data.filter(item => item.PktType === "SNG");
        }
        if (reportType === "MIX") {
            return data.filter(item => item.PktType === "MIX");
        }
        return data; // BOTH → no filter
    }, [data, reportType]);


    const groupedData = useMemo(() => {

        const grouped = {};

        filteredByRptType.forEach((item) => {

            const shape = item.S_Name || "N/A";

            const size =
                groupType === "purity"
                    ? item?.Q_Name || "N/A"
                    : groupType === "color"
                        ? item?.Sh_Name || "N/A"
                        : item.ExSize || "N/A";

            const stk = item.StkAt || "N/A";

            /* ---------------- FILTERS ---------------- */

            // SHAPE FILTER
            if (
                selectedFilter?.shape.length > 0 &&
                !selectedFilter?.shape.includes(shape)
            ) {
                return;
            }

            // SIZE FILTER
            if (
                selectedFilter?.size.length > 0 &&
                !selectedFilter?.size.includes(size)
            ) {
                return;
            }

            // REMOVE N/A
            if (size === "N/A") return;

            /* ---------------- GROUPING ---------------- */

            if (!grouped[shape]) grouped[shape] = {};

            if (!grouped[shape][size]) {
                grouped[shape][size] = {};
            }

            if (!grouped[shape][size][stk]) {

                grouped[shape][size][stk] = {
                    Nos: 0,
                    Weight: 0,
                    Rate: 0,
                    S_Rate: 0,
                };
            }

            grouped[shape][size][stk].Nos += Number(item.Nos || 0);

            grouped[shape][size][stk].Weight += Number(item.Weight || 0);

            grouped[shape][size][stk].Rate += Number(item.Rate || 0);

            grouped[shape][size][stk].S_Rate += Number(item.S_Rate || 0);

        });

        return grouped;

    }, [
        filteredByRptType,
        groupType,
        selectedFilter
    ]);


    /* ===================== DYNAMIC STOCK ===================== */

    const excludedStkAt = [
        "InwardMix",
        "InwardSng",
        "SaleMix",
        "SaleSng",
        "MemoMix", "MemoSng"
    ];

    const dynamicStkAt = useMemo(() => {
        return [...new Set(filteredByRptType.map(d => d.StkAt))]
            .filter(stk => stk && !excludedStkAt.includes(stk));
    }, [filteredByRptType]);

    const getValue = (stkData, stk) => stkData?.[stk] || { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 };


    /* ===================== GRAND TOTAL ===================== */



    useEffect(() => {
        if (reportType == "" || reportType == null) {
            setReportType("SNG")
        }
    }, [reportType])

    const handleLotSelect = (lotCode) => {
        setSelectedLots((prev) => {
            if (prev.includes(lotCode)) {
                // unselect
                return prev.filter(code => code !== lotCode);
            } else {
                // select
                return [...prev, lotCode];
            }
        });
    };

    const handleLotDetail = () => {
        if (selectedLots && selectedLots.length > 0) {
            dispatch(setDetailLotno(selectedLots))
            navigate(linksUrl.rptLotwiseDetail)
        }
        else {
            toast.error("select Lot No To Get Info", {
                "position": "top-center"
            })
        }
    }

    const fixColumn = ["Nos", "Weight", "Rate", "S_Rate"]
    const computeSpecialStocks = (stkData, dynamicStkAt, isStkAtWise) => {
        const mixStock = {
            Nos: getValue(stkData, "InwardMix").Nos - getValue(stkData, "SaleMix").Nos,
            Weight: getValue(stkData, "InwardMix").Weight - getValue(stkData, "SaleMix").Weight,
            Rate: getValue(stkData, "InwardMix").Rate - getValue(stkData, "SaleMix").Rate,
            S_Rate: getValue(stkData, "InwardMix").S_Rate - getValue(stkData, "SaleMix").S_Rate,
        };

        const dynamicStock = dynamicStkAt.reduce(
            (acc, stk) => {
                const v = getValue(stkData, stk);
                acc.Nos += v.Nos;
                acc.Weight += v.Weight;
                acc.Rate += v.Rate;
                acc.S_Rate += v.S_Rate;
                return acc;
            },
            { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 }
        );

        const singleStock = { ...dynamicStock };


        const totalStock = {
            Nos: mixStock.Nos + dynamicStock.Nos + getValue(stkData, "MemoSng").Nos,
            Weight: mixStock.Weight + dynamicStock.Weight + getValue(stkData, "MemoSng").Weight,
            Rate: mixStock.Rate + dynamicStock.Rate + getValue(stkData, "MemoSng").Rate,
            S_Rate: mixStock.S_Rate + dynamicStock.S_Rate + getValue(stkData, "MemoSng").S_Rate,
        };

        return { mixStock, dynamicStock, singleStock, totalStock };
    };

    const grandTotal = Object.values(groupedData).reduce((accShape, sizeData) => {
        Object.values(sizeData).forEach((stkData) => {
            dynamicStkAt.forEach((stk) => {
                const v = stkData?.[stk] || {};
                accShape.Nos += Number(v.Nos || 0);
                accShape.Weight += Number(v.Weight || 0);
                accShape.Rate += Number(v.Rate || 0);
                accShape.S_Rate += Number(v.S_Rate || 0);
            });
        });

        return accShape;
    }, { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 });
    const handleFilter = () => {
        funLoadData(selColor, selPurity)
    }
    const handleResetFilter = () => {
        setSelColor(new Set([]));
        setSelPurity(new Set([]))
        funLoadData(null, null)
    }
    const handleDelet = (key, name) => {
        if (name == 'shape') {
            const newFilter = "selShape"
            newFilter.delete(key)
            setSelShape(new Set(newFilter));
        }
        else if (name == 'color') {
            const newFilter = selColor
            newFilter.delete(key)
            setSelColor(new Set(newFilter));
        }
        else if (name == 'purity') {
            const newFilter = selPurity
            newFilter.delete(key)
            setSelPurity(new Set(newFilter));
        }
        else if (name == 'fancycolor') {
            const newFilter = selFancyColor
            newFilter.delete(key)
            setSelFancyColor(new Set(newFilter));
        }
    }
    const CurrentGroup = useMemo(() => {
        return groupType == "color" ? "Color" : groupType == "purity" ? "Purity" : "Size"
    }, [groupType])
    /* ===================== RENDER ===================== */
    const uniqueValuesMap = useMemo(() => {

        const getSize = (item) => {

            if (groupType === "purity") {
                return item?.Q_Name;
            }

            if (groupType === "color") {
                return item?.Sh_Name;
            }

            return item?.ExSize;
        };

        return {
            shape: [...new Set(data.map(d => d.S_Name).filter(Boolean))],

            size: [...new Set(data.map(getSize).filter(Boolean))],

            stkAt: [...new Set(data.map(d => d.StkAt).filter(Boolean))],
        };

    }, [data, groupType]);

    const handleRemoveTag = (field, value) => {

        setSelectedFilter((prev) => ({
            ...prev,

            [field]: prev[field].filter(
                (v) => v !== value
            ),
        }));
    };

    const handleExportExcel = async () => {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Stock Report");

        /* =========================
           COLUMN TYPE COLORS
        ========================= */

        const columnColors = {
            dynamic: "E0F2FE", // cyan
            fixed: "DCFCE7",   // green
            mix: "FEF3C7",     // amber
            total: "FEE2E2",   // red
        };

        const getColumnType = (stk) => {
            if (dynamicStkAt.includes(stk)) return "dynamic";
            if (visibleFixedCols.includes(stk)) return "fixed";
            if (stk === "MixStock") return "mix";
            if (stk === "TotalStock") return "total";
            return null;
        };

        /* =========================
           STOCK COLUMNS
        ========================= */

        const stockColumns = [
            ...dynamicStkAt,
            ...visibleFixedCols,
            ...(showMixStock ? ["MixStock"] : []),
            ...(showTotalStock ? ["TotalStock"] : []),
        ];

        const subCols = ["Pcs", "Weight", "Value (₹)", "Value ($)"];

        /* =========================
           REPORT HEADER
        ========================= */

        const rptTitle = `Shape And ${CurrentGroup} Wise Stock Report`;
        worksheet.mergeCells("A1:J1");
        worksheet.getCell("A1").value = compName.join(",") || "";
        worksheet.getCell("A1").alignment = { horizontal: "center" };
        worksheet.getCell("A1").font = { bold: true, size: 15 };

        worksheet.mergeCells("A2:J2");
        worksheet.getCell("A2").value = rptTitle
        worksheet.getCell("A2").alignment = { horizontal: "center" };
        worksheet.getCell("A2").font = { bold: true, size: 12 };

        worksheet.mergeCells("A3:J3");
        worksheet.getCell("A3").value = `Export Date: ${new Date().toLocaleString()}`;

        worksheet.mergeCells("A4:J4");
        worksheet.getCell("A4").value = "";

        /* =========================
           HEADER ROWS
        ========================= */

        const headerRow1 = 6;
        const headerRow2 = 7;

        const styleHeader = (cell, bg = "1D4ED8") => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bg },
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };
        };

        /* =========================
           SHAPE + SIZE HEADER
        ========================= */

        worksheet.mergeCells(headerRow1, 1, headerRow2, 1);
        worksheet.getCell(headerRow1, 1).value = "Shape";
        styleHeader(worksheet.getCell(headerRow1, 1));

        worksheet.mergeCells(headerRow1, 2, headerRow2, 2);
        worksheet.getCell(headerRow1, 2).value = CurrentGroup;
        styleHeader(worksheet.getCell(headerRow1, 2));

        /* =========================
           STOCK HEADER
        ========================= */

        let col = 3;

        stockColumns.forEach((stk) => {

            let headerBg = "F1F5F9";

            if (dynamicStkAt.includes(stk)) headerBg = "06B6D4";
            else if (visibleFixedCols.includes(stk)) headerBg = "10B981";
            else if (stk === "MixStock") headerBg = "F59E0B";
            else if (stk === "TotalStock") headerBg = "EF4444";

            worksheet.mergeCells(headerRow1, col, headerRow1, col + 3);

            const headerCell = worksheet.getCell(headerRow1, col);
            headerCell.value = fixedStkAtHeader[stk] || stk;
            styleHeader(headerCell, headerBg);

            for (let i = 0; i < 4; i++) {
                const cell = worksheet.getCell(headerRow2, col + i);

                cell.value = subCols[i];
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center" };

                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: headerBg },
                };

                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                    bottom: { style: "thin" },
                };
            }

            col += 4;
        });

        /* =========================
           BODY ROWS
        ========================= */

        let rowIndex = headerRow2 + 1;

        Object.entries(groupedData).forEach(([shape, sizeData]) => {

            Object.entries(sizeData).forEach(([size, stkData], i) => {

                const row = [];

                row.push(i === 0 ? shape : "");
                row.push(size);

                stockColumns.forEach((stk) => {

                    let values = stkData?.[stk] || {};

                    if (stk === "MixStock") {
                        values = {
                            Nos: (stkData?.InwardMix?.Nos || 0) - (stkData?.SaleMix?.Nos || 0),
                            Weight: (stkData?.InwardMix?.Weight || 0) - (stkData?.SaleMix?.Weight || 0),
                            Rate: (stkData?.InwardMix?.Rate || 0) - (stkData?.SaleMix?.Rate || 0),
                            S_Rate: (stkData?.InwardMix?.S_Rate || 0) - (stkData?.SaleMix?.S_Rate || 0),
                        };
                    }

                    if (stk === "TotalStock") {
                        values = dynamicStkAt.reduce((acc, d) => {
                            const v = stkData?.[d] || {};
                            acc.Nos += Number(v.Nos || 0);
                            acc.Weight += Number(v.Weight || 0);
                            acc.Rate += Number(v.Rate || 0);
                            acc.S_Rate += Number(v.S_Rate || 0);
                            return acc;
                        }, { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 });
                    }

                    row.push(values.Nos || 0);
                    row.push(values.Weight || 0);
                    row.push(values.Rate || 0);
                    row.push(values.S_Rate || 0);
                });

                const added = worksheet.addRow(row);

                /* =========================
                   COLUMN BASED COLORING (FINAL FIX)
                ========================= */

                added.eachCell((cell, colNumber) => {

                    // Shape column
                    if (colNumber === 1) {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "F9FAFB" },
                        };
                        cell.font = {
                            bold: true
                        };

                    }

                    // Size column
                    else if (colNumber === 2) {
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "DBEAFE" },
                        };
                    }

                    // STOCK columns → based on header type
                    else {

                        const stkIndex = colNumber - 3;
                        const stk = stockColumns[Math.floor(stkIndex / 4)];

                        const type =
                            dynamicStkAt.includes(stk) ? "dynamic" :
                                visibleFixedCols.includes(stk) ? "fixed" :
                                    stk === "MixStock" ? "mix" :
                                        stk === "TotalStock" ? "total" : null;

                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: {
                                argb: columnColors[type] || "FFFFFF",
                            },
                        };
                    }

                    cell.border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        right: { style: "thin" },
                        bottom: { style: "thin" },
                    };

                    cell.alignment = {
                        horizontal: "center",
                        vertical: "middle",
                    };
                });

                rowIndex++;
            });
        });

        /* =========================
           GRAND TOTAL (UNCHANGED)
        ========================= */

        const grand = ["Grand Total", ""];

        stockColumns.forEach((stk) => {
            subCols.forEach((k) => {

                let total = 0;

                Object.values(groupedData).forEach((sizeData) => {
                    Object.values(sizeData).forEach((stkData) => {

                        if (stk === "MixStock") {
                            total += (stkData?.InwardMix?.[k] || 0) - (stkData?.SaleMix?.[k] || 0);
                        } else if (stk === "TotalStock") {
                            dynamicStkAt.forEach((d) => {
                                total += Number(stkData?.[d]?.[k] || 0);
                            });
                        } else {
                            total += Number(stkData?.[stk]?.[k] || 0);
                        }
                    });
                });

                grand.push(total);
            });
        });

        const totalRow = worksheet.addRow(grand);

        totalRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "1E40AF" },
            };
            cell.alignment = { horizontal: "center" };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };
        });

        /* =========================
           FINAL SETTINGS
        ========================= */

        worksheet.columns.forEach((c) => (c.width = 14));
        worksheet.getColumn(1).width = 20;
        worksheet.getColumn(2).width = 15;

        worksheet.views = [
            {
                state: "frozen",
                xSplit: 2,
                ySplit: headerRow2,
            },
        ];

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(new Blob([buffer]), `${rptTitle}.xlsx`);
    };

    const handleAddSize = () => {
        dispatch(resetDetail())
        window.open(linksUrl.diamondParamater.polishSize.createpolishSizeMaster, "_blank");
    }
    if(isPending)
    {
        return<LoadingCard/>
    }
     if(isError)
    {
        return<ErrorCard/>
    }
    return (
        <MainContainer pageName="Shape / Size / Purity Wise Stock Summary" info={[]} breadcrumbs={["Reports", "Stock", "Shape / Size / Purity Wise Stock Summary"]}>
            <div className="bg-white p-2 h-screen">
                <div className="flex gap-2 flex-wrap sm:flex-nowrap md:flex-nowrap">
                    <Select
                        size="sm"
                        name={formField.colorCode}
                        label={"Color"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="multiple"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"--select-"}
                        className="w-full"
                        classNames={{
                            label: "text-xs font-semibold",
                        }}

                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.colorMaster ? masterData.colorMaster : []
                        }
                        renderValue={(items) => {
                            return (
                                <div className="flex gap-2 w-full" >
                                    {items.map((item) => (
                                        <div key={item.Sh_Code} className="flex  text-xs">
                                            <Chip
                                                key={item.Sh_Code}
                                                label={item.data.Sh_Name}
                                                onDelete={() => handleDelet(item.key, 'color')}
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ height: 22, fontSize: "10px" }}
                                            />
                                            {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.S_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.S_Name}</strong></Chip>
                                                                    <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'shape')} icon={faCircleXmark} /></div> */}
                                        </div>
                                    ))}
                                </div>
                            );
                        }}
                        onSelectionChange={setSelColor}
                        selectedKeys={selColor}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.Sh_Code}
                            >
                                {list.Sh_Name}
                            </SelectItem>
                        )}
                    </Select>
                    <Select
                        size="sm"
                        name={formField.purityCode}
                        label={"Purity"}
                        color="default"
                        eventResizeFeature={true}
                        selectionMode="multiple"
                        labelPlacement="outside"
                        showScrollIndicators={true}
                        placeholder={"--select-"}
                        className="w-full"
                        classNames={{
                            label: "text-xs font-semibold",
                        }}

                        variant="bordered"
                        isVirtualized
                        items={
                            masterData && masterData?.purityMaster ? masterData.purityMaster : []
                        }
                        renderValue={(items) => {
                            return (
                                <div className="flex gap-2 w-full" >
                                    {items.map((item) => (
                                        <div key={item.Q_Code} className="flex  text-xs">
                                            <Chip
                                                key={item.Q_Code}
                                                label={item.data.Q_Name}
                                                onDelete={() => handleDelet(item.key, 'purity')}
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{ height: 22, fontSize: "10px" }}
                                            />
                                            {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.S_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.S_Name}</strong></Chip>
                                                                    <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'shape')} icon={faCircleXmark} /></div> */}
                                        </div>
                                    ))}
                                </div>
                            );
                        }}
                        onSelectionChange={setSelPurity}
                        selectedKeys={selPurity}
                    >
                        {(list) => (
                            <SelectItem
                                key={list.Q_Code}
                            >
                                {list.Q_Name}
                            </SelectItem>
                        )}
                    </Select>
                    <div className={`flex gap-4  flex-nowrap mt-2  justify-center items-center `}>

                        {/* </div>
                                            <div className={`flex  items-center gap-2 `}> */}
                        <Button
                            size="sm"
                            color="primary"
                            className="bg-pink-600 max-w-28"
                            startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                            onPress={handleFilter}

                        // isLoading={isPending}
                        >
                            Find Stock
                        </Button>
                        <Button
                            style={{ marginLeft: "5px" }}
                            color="primary"
                            size="sm"
                            className="max-w-22 bg-slate-700"
                            startContent={<FontAwesomeIcon icon={faFilter} />}
                            onPress={handleResetFilter}
                        >
                            Reset
                        </Button>
                    </div>
                </div>
                {data && data.length > 0 ?
                    <div className="mb-5">


                        {/* <h2 className="text-orange-500  text-left font-semibold text-sm">Total Records : {Object.keys(groupedData)?.length || 0}</h2> */}
                        <div className="mb-2 flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-between w-full items-center shadow p-2 gap-x-2 gap-y-2">

                            {/* Left buttons */}


                            {/* Right controls */}
                            <div className="flex flex-nowrap items-center justify-end gap-y-1 gap-x-5">
                                <Select
                                    selectedKeys={[groupType]}
                                    // variant="flat"
                                    color="danger"
                                    size="sm"
                                    label="View Type : "
                                    labelPlacement="outside"
                                    variant={"underlined"}
                                    onChange={(e) => setGroupType(e.target.value)}
                                    classNames={{ label: "xs" }}
                                    className=" bg-pink-50   border-2 border-pink-400  sm:w-40 md:w-40 w-28 border-1 text-sm font-semibold"
                                >
                                    <SelectItem key="size">Shape - Size</SelectItem>
                                    <SelectItem key="purity">Shape - Purity</SelectItem>
                                    <SelectItem key="color">Shape - Color</SelectItem>
                                </Select>
                                <Select
                                    selectedKeys={[reportType]}
                                    variant="underlined"
                                    color="warning"
                                    size="sm"
                                    label="Stock Type : "
                                    labelPlacement="outside"
                                    onChange={(e) => setReportType(e.target.value)}
                                    classNames={{ label: "xs" }}
                                    className=" bg-amber-50 border-1 border-amber-400 sm:w-40 md:w-40 w-28 border-1 text-sm font-semibold"
                                >

                                    <SelectItem key="MIX">MIX</SelectItem>
                                    <SelectItem key="SNG">SINGLE</SelectItem>
                                </Select>

                            </div>
                            <div className="flex flex-nowrap gap-x-2 gap-y-2 justify-end">
                                <button onClick={handleAddSize} className="text-xs text-blue-700 font-semibold bg-blue-50 rounded-sm p-1 px-2 underline  " >Add Polish Size</button>
                                <button
                                    onClick={handleExportExcel}
                                    className="bg-red-600 text-white whitespace-nowrap h-7 px-3 py-1 rounded text-sm"
                                >
                                    Export Excel
                                </button>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                                alignItems: "center",
                                marginBottom: "5px"
                            }}
                        >
                            {Object.entries(selectedFilter).map(([field, values]) => {

                                if (!values?.length) return null;

                                return (
                                    <div
                                        key={field}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {/* FIELD LABEL */}
                                        <strong
                                            className="text-xs uppercase text-gray-600"
                                            style={{ fontSize: "0.65rem" }}
                                        >
                                            {field} :
                                        </strong>

                                        {/* CHIPS */}
                                        {values.map((value) => (
                                            <Chip
                                                key={`${field}-${value}`}
                                                label={value}
                                                onDelete={() =>
                                                    handleRemoveTag(field, value)
                                                }
                                                size="small"
                                                color="secondary"
                                                variant="outlined"
                                                sx={{
                                                    height: 22,
                                                    fontSize: "11px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                        <div className=" border-1  border-slate-500 overflow-auto max-h-[60vh]">
                            <table className="min-w-max border-separate border-spacing-0 text-sm">
                                <thead className="sticky top-0 z-40 bg-gray-100 shadow-md">

                                    <tr className="text-xs uppercase">

                                        <th className={`${StickyLeftCellShape}  bg-blue-600 text-white `}>
                                            Shape

                                        </th>

                                        <th className={`${StickyLeftCellSize} bg-blue-600 text-white`}>
                                            {CurrentGroup}
                                        </th>

                                        {/* DYNAMIC */}
                                        {showDynamicStock &&
                                            dynamicStkAt.map((stk) => (
                                                <th key={stk} colSpan={4} className={`${getStockClass("dynamic", "head")}`}>
                                                    {stk}
                                                </th>
                                            ))
                                        }

                                        {/* FIXED */}
                                        {visibleFixedCols.map((stk) => (
                                            <th key={stk} colSpan={4} className={`${getStockClass("fixed", "head")}`}>
                                                {fixedStkAtHeader[stk] || stk}
                                            </th>
                                        ))}

                                        {/* MIX */}
                                        {showMixStock && (
                                            <th colSpan={4} className={`${getStockClass("mix", "head")}`}>
                                                Mix Stock
                                            </th>
                                        )}

                                        {/* TOTAL */}
                                        {showTotalStock && (
                                            <th colSpan={4} className={`${getStockClass("mix", "head")}`}>
                                                Total Stock
                                            </th>
                                        )}
                                    </tr>
                                    <tr className="text-[11px] font-semibold">
                                        <th className={`${StickyLeftCellShape} ${stickyFilterCell}`}>
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                options={uniqueValuesMap?.shape || []}
                                                value={selectedFilter?.shape || ""}
                                                onChange={(e, value) => {
                                                    setSelectedFilter((prev) => ({
                                                        ...prev,
                                                        shape: value,
                                                    }));
                                                }}
                                                noOptionsText="No options available"
                                                renderTags={() => null}
                                                slotProps={{
                                                    chip: {
                                                        size: "small",
                                                        sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                                                    },
                                                    input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                                                    popper: { sx: { fontSize: "12px" } },
                                                    listbox: {
                                                        sx: {
                                                            fontSize: "11px",
                                                            "& .MuiAutocomplete-option": {
                                                                padding: "2px 8px", minHeight: "28px",
                                                                "&.Mui-selected": {
                                                                    backgroundColor: "#f3ea6fff !important",
                                                                    color: "#000 !important",
                                                                },
                                                                // Change background color when focused via keyboard navigation
                                                                "&.Mui-focused": {
                                                                    backgroundColor: "rgb(244, 247, 191)",
                                                                },
                                                            },

                                                        }
                                                    }
                                                }}
                                                sx={{
                                                    "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
                                                    "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" },

                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Find..."
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{
                                                            ...params.inputProps, // ⚡ make sure inputProps exist
                                                            autoComplete: "off"
                                                        }}
                                                        sx={{
                                                            //  width: ["S_Name", "BrokerDesc", "PartyName"].includes(col.key) ? "250px" : "140px",
                                                            width: "100%",
                                                            "& .MuiInputLabel-root": { fontSize: "10px", color: "#054195", fontWeight: 600 }
                                                        }}
                                                    />
                                                )}
                                            /></th>
                                        <th className={`${StickyLeftCellSize} ${stickyFilterCell}`} >
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                options={uniqueValuesMap?.size || []}
                                                value={selectedFilter?.size || ""}
                                                onChange={(e, value) => {
                                                    setSelectedFilter((prev) => ({
                                                        ...prev,
                                                        size: value,
                                                    }));
                                                }}
                                                noOptionsText="No options available"
                                                renderTags={() => null}
                                                slotProps={{
                                                    chip: {
                                                        size: "small",
                                                        sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
                                                    },
                                                    input: { sx: { padding: "2px 0px !important", fontSize: "11px" } },
                                                    popper: { sx: { fontSize: "12px" } },
                                                    listbox: {
                                                        sx: {
                                                            fontSize: "11px",
                                                            "& .MuiAutocomplete-option": {
                                                                padding: "2px 8px", minHeight: "28px",
                                                                "&.Mui-selected": {
                                                                    backgroundColor: "#f3ea6fff !important",
                                                                    color: "#000 !important",
                                                                },
                                                                // Change background color when focused via keyboard navigation
                                                                "&.Mui-focused": {
                                                                    backgroundColor: "rgb(244, 247, 191)",
                                                                },
                                                            },

                                                        }
                                                    }
                                                }}
                                                sx={{
                                                    "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
                                                    "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" },

                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Find..."
                                                        variant="outlined"
                                                        size="small"
                                                        nputProps={{
                                                            ...params.inputProps, // ⚡ make sure inputProps exist
                                                            autoComplete: "off"
                                                        }}
                                                        sx={{
                                                            //  width: ["S_Name", "BrokerDesc", "PartyName"].includes(col.key) ? "250px" : "140px",
                                                            width: "100%",
                                                            "& .MuiInputLabel-root": { fontSize: "10px", color: "#054195", fontWeight: 600 }
                                                        }}
                                                    />
                                                )}
                                            /></th>                                    {[
                                                ...dynamicStkAt,
                                                ...visibleFixedCols,
                                                ...(showMixStock ? ["MixStock"] : []),
                                                ...(showTotalStock ? ["TotalStock"] : []),
                                            ].flatMap((col) =>
                                                ["Pcs", "Weight", "Value (₹)", "Value ($)"].map((sub) => (
                                                    <th
                                                        key={`${col}-${sub}`}
                                                        className="border p-2 text-xs bg-white text-gray-600"
                                                    >
                                                        {sub}
                                                    </th>
                                                ))
                                            )}

                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(groupedData).map(([shape, sizeData]) => {

                                        /* FILTER VALID ROWS */
                                        const filteredRows = Object.entries(sizeData).filter(([size, stkData]) => {

                                            // remove N/A size
                                            if (size === "N/A") return false;

                                            // check all stock values
                                            const hasValue = Object.values(stkData).some((stk) =>
                                                fixColumn.some((k) => Number(stk?.[k] || 0) !== 0)
                                            );

                                            return hasValue;
                                        });

                                        return filteredRows.map(([size, stkData], rowIndex) => {

                                            const totalStock = dynamicStkAt.reduce(
                                                (acc, stk) => {
                                                    const v = stkData?.[stk] || {};

                                                    acc.Nos += Number(v.Nos || 0);
                                                    acc.Weight += Number(v.Weight || 0);
                                                    acc.Rate += Number(v.Rate || 0);
                                                    acc.S_Rate += Number(v.S_Rate || 0);

                                                    return acc;
                                                },
                                                { Nos: 0, Weight: 0, Rate: 0, S_Rate: 0 }
                                            );

                                            const formatCell = (k, value) => {
                                                const num = Number(value || 0);

                                                if (k === "Rate")
                                                    return formatCurrency(num);

                                                return num.toLocaleString(undefined, {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 2,
                                                });
                                            };

                                            return (
                                                <tr
                                                    key={`${shape}-${size}`}
                                                    className="z-50
                       
                        hover:bg-cyan-50
                        transition-all
                        duration-150
                        border-b border-slate-200
                    "
                                                >

                                                    {/* SHAPE */}
                                                    <td
                                                        className={`
                            ${StickyLeftCellShape}
                             bg-gray-50 
                       
                            text-xs uppercase tracking-wider
                            font-bold text-blue-700
                            border-b border-r border-blue-300
                            shadow-sm
                        `}
                                                    >
                                                        {rowIndex === 0 ? shape : ""}
                                                    </td>

                                                    {/* SIZE */}
                                                    <td
                                                        className={`
                            ${StickyLeftCellSize}
                            bg-blue-50
                            text-xs font-bold text-slate-700
                            border-b border-r border-blue-300
                        `}
                                                    >
                                                        {size}
                                                    </td>

                                                    {/* 🔵 DYNAMIC STOCK */}
                                                    {showDynamicStock &&
                                                        dynamicStkAt.flatMap((stk) =>
                                                            fixColumn.map((k) => {

                                                                const value = stkData?.[stk]?.[k] ?? 0;

                                                                return (
                                                                    <td
                                                                        key={`${shape}-${size}-${stk}-${k}`}
                                                                        className={`
                                            ${cellClass}
                                            ${getStockStyle("dynamic")}
                                            ${getStockBorder("dynamic")}
                                            hover:bg-cyan-100
                                            transition-all
                                            duration-150
                                        `}
                                                                    >
                                                                        {formatCell(k, value)}
                                                                    </td>
                                                                );
                                                            })
                                                        )
                                                    }

                                                    {/* 🟢 FIXED STOCK */}
                                                    {visibleFixedCols.flatMap((stk) =>
                                                        fixColumn.map((k) => {

                                                            const value = stkData?.[stk]?.[k] ?? 0;

                                                            return (
                                                                <td
                                                                    key={`${shape}-${size}-${stk}-${k}`}
                                                                    className={`
                                        ${cellClass}
                                        ${getStockStyle("fixed")}
                                        ${getStockBorder("fixed")}
                                        hover:bg-emerald-100
                                        transition-all
                                        duration-150
                                    `}
                                                                >
                                                                    {formatCell(k, value)}
                                                                </td>
                                                            );
                                                        })
                                                    )}

                                                    {/* 🟠 MIX STOCK */}
                                                    {showMixStock &&
                                                        fixColumn.map((k) => {

                                                            const mix =
                                                                (stkData?.InwardMix?.[k] || 0) -
                                                                (stkData?.SaleMix?.[k] || 0);

                                                            return (
                                                                <td
                                                                    key={`${shape}-${size}-mix-${k}`}
                                                                    className={`
                                        ${cellClass}
                                        ${getStockStyle("mix")}
                                        ${getStockBorder("mix")}
                                        hover:bg-amber-100
                                        transition-all
                                        duration-150
                                    `}
                                                                >
                                                                    {formatCell(k, mix)}
                                                                </td>
                                                            );
                                                        })
                                                    }

                                                    {/* 🔴 TOTAL STOCK */}
                                                    {showTotalStock &&
                                                        fixColumn.map((k) => (
                                                            <td
                                                                key={`${shape}-${size}-total-${k}`}
                                                                className={`
                                    ${cellClass}
                                    ${getStockStyle("total")}
                                    ${getStockBorder("total")}
                                    font-bold
                                    shadow-sm
                                    hover:bg-rose-100
                                `}
                                                            >
                                                                {formatCell(k, totalStock[k])}
                                                            </td>
                                                        ))
                                                    }

                                                </tr>
                                            );
                                        });
                                    })}
                                </tbody>
                                <tr className="sticky bottom-0 z-50 bg-white  text-gray-900 font-bold  border-t-2 border-gray-500 shadow-[2px_0_6px_rgba(0,0,0,0.12)]">
                                    <td className={`${StickyLeftCellShape} bg-blue-600 text-white`}>Grand Total</td>
                                    <td className={`${StickyLeftCellSize} bg-blue-600`}></td>

                                    {/* DYNAMIC */}
                                    {dynamicStkAt.flatMap((stk) =>
                                        fixColumn.map((k) => {
                                            const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                Object.values(sizeData).forEach((stkData) => {
                                                    const v = stkData?.[stk] || {};
                                                    acc += Number(v[k] || 0);
                                                });
                                                return acc;
                                            }, 0);

                                            return (
                                                <td key={`gt-${stk}-${k}`} className={`text-center border p-2 ${getStockClass("dynamic", "head")} bg-white`}>
                                                    {k === "Rate"
                                                        ? formatCurrency(total)
                                                        : total.toFixed(2)}
                                                </td>
                                            );
                                        })
                                    )}

                                    {/* FIXED */}
                                    {visibleFixedCols.flatMap((stk) =>
                                        fixColumn.map((k) => {
                                            const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                Object.values(sizeData).forEach((stkData) => {
                                                    const v = stkData?.[stk] || {};
                                                    acc += Number(v[k] || 0);
                                                });
                                                return acc;
                                            }, 0);

                                            return (
                                                <td key={`gt-fixed-${stk}-${k}`} className={`text-center border ${getStockClass("fixed", "head")} bg-white`}>
                                                    {k === "Rate"
                                                        ? formatCurrency(total)
                                                        : total.toFixed(2)}
                                                </td>
                                            );
                                        })
                                    )}

                                    {/* MIX */}
                                    {showMixStock &&
                                        fixColumn.map((k) => {
                                            const total = Object.values(groupedData).reduce((acc, sizeData) => {
                                                Object.values(sizeData).forEach((stkData) => {
                                                    const v1 = stkData?.InwardMix?.[k] || 0;
                                                    const v2 = stkData?.SaleMix?.[k] || 0;
                                                    acc += (v1 - v2);
                                                });
                                                return acc;
                                            }, 0);

                                            return (
                                                <td key={`gt-mix-${k}`} className={`text-center border ${getStockClass("mix", "head")} bg-white`}>
                                                    {k === "Rate"
                                                        ? formatCurrency(total)
                                                        : total.toFixed(2)}
                                                </td>
                                            );
                                        })
                                    }

                                    {/* TOTAL */}

                                    {showTotalStock && fixColumn.map((k) => (
                                        <td key={`gt-total-${k}`} className={`text-center border font-bold ${getStockClass("mix", "head")} bg-white`}>
                                            {k === "Rate"
                                                ? formatCurrency(grandTotal[k])
                                                : grandTotal[k].toFixed(2)}
                                        </td>
                                    ))}
                                </tr>
                            </table>
                        </div>
                    </div> :
                    <Box sx={{
                        p: 4,
                        textAlign: 'center',
                        border: `1px dashed gray`,
                        borderRadius: 2,
                        backgroundColor: 'background.default'

                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                        }}>
                            <FontAwesomeIcon icon={faInfo} />
                            {/* <DescriptionOutlined sx={{
                                  fontSize: 48,
                                  color: 'text.disabled'
                                }} /> */}
                            <Typography variant="h6" color="text.secondary">
                                No  data available
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Apply filters above to generate a report
                            </Typography>
                        </Box>
                    </Box>}
            </div>
        </MainContainer>
    );
};

export default ParamWisePositionReport

